import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export default function BinIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <g fill="none">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M17.5 6V18.75C17.5 19.993 16.473 21 15.231 21H7.731C6.488 21 5.5 19.993 5.5 18.75V6M19 6H4M9.5 3H13.5M13.5 10V17M9.5 17V10"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgIcon>
  );
}
